<template>
    <div class="container">
    </div>
</template>

<script>
import { oilHotaPageRequest } from '@/api/floor'
import { times } from 'number-precision';
import { Dialog } from 'vant';

export default {
    name: "oilHotalMiddlePage",
    data() {
        return {
            orderType: ''
        }
    },
    methods: {
        requestHandle() {
            if ('tkty' == this.orderType) {
                //定位
                if (navigator.geolocation) {
                    this.$toast.loading({
                        duration: 0,
                        message: '加载中...',
                        forbidClick: true
                    })
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            this.$toast.clear()
                            const crd = position.coords
                            //经纬度先写死latitude=39.932293longitude=116.535525
                            oilHotaPageRequest({ longitude: crd.longitude, latitude: crd.latitude, orderType: this.orderType }).then(res => {
                                if (res.data) {
                                    window.location.href = res.data;
                                }
                            }).catch(err => {
                            })
                        }, (err) => {
                            this.$toast.clear()
                            Dialog.confirm({
                                title: '提示',
                                message: '定位获取失败,请重试',
                                confirmButtonText: '确定',
                                showCancelButton: false,
                            }).then(() => {
                                // on confirm
                                this.handleBack()
                            }).catch(() => {
                                // on cancel
                            });
                        }, { timeout: 5000 }
                    )
                } else {
                    //浏览器不支持定位,返回
                    Dialog.confirm({
                        title: '提示',
                        message: '定位获取失败,请重试',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showCancelButton: false,
                    }).then(() => {
                        // on confirm
                        this.handleBack()
                    }).catch(() => {
                        // on cancel
                    });
                }
            } else {
                //不需要定位送空值
                oilHotaPageRequest({ longitude: '', latitude: '', orderType: this.orderType }).then(res => {
                    if (res.data) {
                        window.location.href = res.data;
                    }
                }).catch(err => {

                })
            }

        },
        // 返回按钮
        handleBack() {
            const userAgent = window.navigator.userAgent
            if (userAgent.match(/MicroMessenger\//gi)) { // 微信环境
                wx.miniProgram.navigateBack()
            } else { // H5环境
                appObj.appCloseCurrentWebView()
            }
        },
        verifyLogin() {
            oilHotaPageRequest({ longitude: '', latitude: '', orderType: this.orderType }).then(res => {
                if (200 == res.code) {
                    this.requestHandle();
                }
            }).catch(err => {
                console.log(err);
            })
        }
    },
    mounted() {
        this.orderType = this.$route.query.orderType;
        //先请求一次登录
        this.verifyLogin()
        // this.requestHandle();
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    padding: 0.1rem;
    box-sizing: border-box;
    align-items: center;
}
</style>